import L from "leaflet";
import { Marker, Tooltip } from "react-leaflet";

// Nodos de un desvío editado: el operador los arrastra y el trazado entre ellos sigue las calles (lo calcula el servidor).
// Círculos numerados = nodos; «+» entre dos nodos = añadir uno; clic derecho sobre un nodo = quitarlo (quedan al menos dos).
const node = (n, ends) => L.divIcon({
  className: "",
  html: `<div style="width:22px;height:22px;border-radius:50%;background:${ends ? "#15803d" : "#ffffff"};color:${ends ? "#fff" : "#15803d"};border:3px solid #15803d;display:grid;place-items:center;font:700 10px/1 Inter,sans-serif;box-shadow:0 2px 6px rgb(0 0 0 / .35);cursor:grab">${n}</div>`,
  iconSize: [22, 22], iconAnchor: [11, 11],
});
const PLUS = L.divIcon({
  className: "",
  html: '<div style="width:16px;height:16px;border-radius:50%;background:#dcfce7;border:2px solid #15803d;color:#15803d;display:grid;place-items:center;font:700 12px/1 Inter,sans-serif;opacity:.9;cursor:copy">+</div>',
  iconSize: [16, 16], iconAnchor: [8, 8],
});
const ll = (e) => [+e.target.getLatLng().lat.toFixed(6), +e.target.getLatLng().lng.toFixed(6)];

export const WaypointEditor = ({ id, waypoints, onChange }) => {
  if (!waypoints?.length) return null;
  const w = waypoints;
  return (
    <>
      {w.map((p, i) => (
        <Marker key={`wp-${id}-${i}-${p[0]}-${p[1]}`} position={p} icon={node(i + 1, i === 0 || i === w.length - 1)} draggable zIndexOffset={2100}
          eventHandlers={{
            dragend: (e) => onChange(w.map((x, j) => (j === i ? ll(e) : x))),
            contextmenu: () => w.length > 2 && onChange(w.filter((_, j) => j !== i)),
            click: (e) => L.DomEvent.stopPropagation(e),
          }}>
          <Tooltip direction="top" offset={[0, -10]}>{i === 0 ? "Inicio del desvío" : i === w.length - 1 ? "Final del desvío" : `Nodo ${i + 1}`} · arrastre para mover{w.length > 2 ? " · clic derecho para quitar" : ""}</Tooltip>
        </Marker>
      ))}
      {w.slice(1).map((q, i) => {
        const p = w[i];
        return (
          <Marker key={`wpm-${id}-${i}-${p[0]}-${q[0]}`} position={[(p[0] + q[0]) / 2, (p[1] + q[1]) / 2]} icon={PLUS} draggable zIndexOffset={2000}
            eventHandlers={{
              dragend: (e) => onChange([...w.slice(0, i + 1), ll(e), ...w.slice(i + 1)]),
              click: (e) => { L.DomEvent.stopPropagation(e); onChange([...w.slice(0, i + 1), [(p[0] + q[0]) / 2, (p[1] + q[1]) / 2], ...w.slice(i + 1)]); },
            }}>
            <Tooltip direction="top" offset={[0, -8]}>Arrastre (o pulse) para añadir un nodo aquí</Tooltip>
          </Marker>
        );
      })}
    </>
  );
};
